module.exports = __webpack_public_path__ + "static/kitchen-e09f5d3d498f780581815599f25a819d.jpeg";